import React from "react";
import Mockman from "mockman-js";
function MockAPI() {
	return (
		<div className="MockAPI">
			<Mockman colorScheme="light"/>
		</div>
	);
}

export default MockAPI;
